import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import { toast } from "react-toastify";
import {
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Toolbar,
  Typography,
  FormControl,
  Link,
  Select,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import MenuIcon from "@mui/icons-material/Menu";
import { styled, useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import partnerLogo from "../../Assets/CompanyImg/partner.png";
import dashlogo from "../../Assets/CompanyImg/Dasboard.png";
import SpeedIcon from "@mui/icons-material/Speed";
import vehiclelogo from "../../Assets/CompanyImg/vehicle.png";
import Logo from "../../Assets/Images/logo.png";
import SettingsIcon from "@mui/icons-material/Settings";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import EditIcon from '@mui/icons-material/Edit';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import GroupIcon from '@mui/icons-material/Group';
import LockIcon from '@mui/icons-material/Lock';
import PeopleIcon from "@mui/icons-material/People";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import EuroIcon from '@mui/icons-material/Euro';
import EditLocationIcon from '@mui/icons-material/EditLocation';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CommuteIcon from '@mui/icons-material/Commute';
import FunctionsIcon from '@mui/icons-material/Functions';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import { resetContact } from "../../redux/reducers/contactReducer";
import { resetHomeRe } from "../../redux/reducers/homeReducer";
import { paths } from "../../config/constants";
import { useDispatch,useSelector } from "react-redux";
import { reset } from "../../redux/reducers/login";
import { authToken } from "../../redux/reducers/login";
import ReceiptLongIcon  from '@mui/icons-material/ReceiptLong';
import DescriptionIcon from '@mui/icons-material/Description';

import axios from "axios";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const LinkWrapper = styled(Link)(() => ({
  color: "#CFC4B7",
  fontFamily: "DM Sans",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  lineHeight: " 21px",
  textDecoration: "none",
}));


export default function DriverCarrierLayout() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);
  const [openDrawer, setOpenDrawer] = React.useState(true);
  const [policy, setPolicy] = useState('Terms and Conditions');
  const [partner, setPartner] = React.useState("part");
  const [toastShown, setToastShown] = useState(false);
  // const loginRole = useSelector(authToken);
  // const loginRoles = loginRole.payload.login.user.data.role
  const reduxdata = useSelector((state) => state);
  const userId = reduxdata?.login?.user?.data?._id;
    let token = reduxdata?.login?.token;
  console.log("userID",userId)
  const dispatch = useDispatch();

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
  };

  const [vehicle, setVehicle] = useState("vehicle1");
  const [zone, setZone] = useState("zone");
  const [price, setPrice] = useState("price");
  const [extraOptions, setExtraOptions] = useState(" ");
  const [isProfileCompleted, setIsProfileCompleted] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [role,setRole]=useState(null)
  const [deactivatedStatusReason,setDeactivatedStatusReason]=useState(null)
    const [bluCommission,setBluCommission]=useState(null)

  const handleChangeVehicle = (event) => {
    setVehicle(event.target.value);
  };

  const handleChangePartner = (event) => {
    setPartner(event.target.value);
  };

  useEffect(() => {
      if (token) {
        const storedTokenTimestamp = localStorage.getItem('tokenTimestamp');
        const currentTime = Date.now();
        const storedTimestamp = parseInt(storedTokenTimestamp, 10);
        const tokenExpirationTime = 1800000;
        if (currentTime - storedTimestamp >= tokenExpirationTime) {
          handleExpire();
        }
      }
    },);
  
  
    const handleExpire = () => {
  
      toast.error("Session Expired!",{autoClose: 2500});
      dispatch(resetContact());
      dispatch(resetHomeRe());
      dispatch(reset());
      sessionStorage.clear();
      localStorage.clear();
      navigate(paths.accounts.login);
      toast.success("Logout Successfully! ",{autoClose: 2500});
  
    }

  const handleLogout = () => {
    dispatch(resetContact());
    dispatch(resetHomeRe());
    dispatch(reset());
    sessionStorage.clear();
    localStorage.clear();
    toast.success("Logout Successfully");
    navigate(paths.accounts.login);
  };

  const handleSelectChange = (e) => {
    const newValue = e.target.value;
       setPolicy(newValue);
  };

const handleMenuItemClick = (value) => {
  if (value === "Terms and Conditions") {
    navigate(paths.driverCarrier.carrierTermsAndConditions); // Navigate to Terms and Conditions page
  } else if (value === "Cancellation Policy") {
    navigate(paths.driverCarrier.carrierCancellationPolicy); // Navigate to Cancellation Policy page
  }
};


  
  const fetchData = async () => {
    let obj = {
      userId: userId,
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL}api/user/getUserProfile`,
        obj
      );
      console.log(res?.data?.data);
      setIsProfileCompleted(res?.data?.data?.isProfileCompleted);
      setAccountType(res?.data?.data?.accountType);
      setRole(res?.data?.data?.role);
      setBluCommission(res?.data?.data?.bluCommission)
      setDeactivatedStatusReason(res?.data?.data?.deactivatedStatusReason)
    } catch (error) {}
  };

  useEffect(() => {
      fetchData();
    }, []);


const handleCreateBookingClick = (event, section) => {
  if (isProfileCompleted === false) {
    event.preventDefault();
    if (!toastShown) {
      const message =
        section === "booking"
          ? "You cannot create a booking because your profile is incomplete. Kindly complete it using Edit Profile."
          : section === "drivers"
          ? "You cannot manage drivers because your profile is incomplete. Kindly complete it using Edit Profile."
          : "You cannot manage vehicles because your profile is incomplete. Kindly complete it using Edit Profile.";

      toast.info(message, { autoClose: 2500 });
      setToastShown(true);
      setTimeout(() => setToastShown(false), 2500);
    }
    return;
  }

  if (bluCommission === null) {
    // Only block commission for booking
    event.preventDefault();
    if (!toastShown) {
     const message =
        section === "booking"
          ? "You cannot create a booking because your commission has not yet been set. Contact customer support."
          : section === "drivers"
          ? "You cannot manage drivers because your commission has not yet been set. Contact customer support."
          : "You cannot manage vehicles because your commission has not yet been set. Contact customer support.";

      toast.info(message, { autoClose: 2500 });
      setToastShown(true);
      setTimeout(() => setToastShown(false), 2500);
    }
    return;
  }
console.log('issue7363', deactivatedStatusReason)
    if (deactivatedStatusReason !== 'N/A') {
    // Only block commission for booking
    event.preventDefault();
    if (!toastShown) {
     const message =
        section === "booking"
          ? `You cannot create a booking because your account is deactivated for this reason: ${deactivatedStatusReason}.`
          : section === "drivers"
          ? `You cannot manage drivers because your your account is deactivated for this reason: ${deactivatedStatusReason}.`
          : `You cannot manage vehicles because your your account is deactivated for this reason: ${deactivatedStatusReason}.`

      toast.info(message, { autoClose: 2500 });
      setToastShown(true);
      setTimeout(() => setToastShown(false), 2500);
    }
    return;
  }
};


  return (
    <>
      <div style={{ backgroundColor: "#F5F4F0" }}>
        <div className="d-flex">
          <CssBaseline />
          <div>
            <Drawer
              variant="permanent"
              open={openDrawer}
              PaperProps={{
                sx: {
                  backgroundColor: "#1A1F23",
                  color: "white",
                },
              }}
            >
              <DrawerHeader>
                <Box display="flex" mt={1}>
                  <Box p={1}>
                    <img src={Logo} width="100%" height="auto" />
                  </Box>
                </Box>
              </DrawerHeader>
              <Divider />
              <List>
                <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink
                      to={paths.driverCarrier.dashboard}
                      className="sidelink"
                    >
                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                        <SpeedIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography sx={{ marginInlineStart: "19px" }}>
                          {" "}
                          Dashboard
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>

                <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink
  to={paths.driverCarrier.openBooking}
  state={{ bluCommission, isProfileCompleted, deactivatedStatusReason }} // ✅ pass it like this
  className="sidelink"
>

                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                       <PhoneInTalkIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography sx={{ marginInlineStart: "19px" }}>
                          {" "}
                          Open Bookings
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>


                 <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink
  to={paths.driverCarrier.assignDriverVehicle}
  className="sidelink"
>

                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                       <PhoneInTalkIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography sx={{ marginInlineStart: "19px" }}>
                          {" "}
                          Assign Driver
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>



                 <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink
                    to={paths.driverCarrier.upcomingBookings}
                    className="sidelink"
                  >

                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                       <PhoneInTalkIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography sx={{ marginInlineStart: "19px" }}>
                          {" "}
                          Upcoming Bookings
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>
                  <span>
                    

               <ListItem disablePadding sx={{ display: "block" }}>
  <NavLink to={paths.driverCarrier.createBooking} className="sidelink">
  <ListItemButton
    onClick={(event) => handleCreateBookingClick(event, "booking")}
    spacing={4}
    sx={{
      minHeight: 48,
      justifyContent: open ? "initial" : "center",
      px: 2.5,
      color: "white",
    }}
  >
    <ListItemIcon
      sx={{
        minWidth: 0,
        mr: open ? 3 : "auto",
        justifyContent: "center",
        color: "white",
      }}
    >
      <PhoneInTalkIcon />
    </ListItemIcon>
    <ListItemText>
      <Typography sx={{ marginInlineStart: "19px" }}>
        Create Booking
      </Typography>
    </ListItemText>
  </ListItemButton>
</NavLink>
</ListItem>

                  </span>


                  <ListItem disablePadding sx={{ display: "block" }}>
                  <NavLink
  to={paths.driverCarrier.myBookings}
  className="sidelink"
>

                    <ListItemButton
                      spacing={4}
                      sx={{
                        minHeight: 48,
                        justifyContent: open ? "initial" : "center",
                        px: 2.5,
                        color: "white",
                      }}
                    >
                      <ListItemIcon
                        sx={{
                          minWidth: 0,
                          mr: open ? 3 : "auto",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                       <PhoneInTalkIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Typography sx={{ marginInlineStart: "19px" }}>
                          {" "}
                          My Bookings
                        </Typography>
                      </ListItemText>
                    </ListItemButton>
                  </NavLink>
                </ListItem>


                                  <span>
                                   <ListItem disablePadding sx={{ display: "block" }}>
                                                      <NavLink to={paths.driverCarrier.driverList} className="sidelink">
  <ListItemButton
    onClick={(event) => handleCreateBookingClick(event, "drivers")}
    spacing={4}
    sx={{
      minHeight: 48,
      justifyContent: open ? "initial" : "center",
      px: 2.5,
      color: "white",
    }}
  >
    <ListItemIcon
      sx={{
        minWidth: 0,
        mr: open ? 3 : "auto",
        justifyContent: "center",
        color: "white",
      }}
    >
      <GroupIcon />
    </ListItemIcon>
    <ListItemText>
      <Typography sx={{ marginInlineStart: "19px" }}>
        Add / Edit Drivers
      </Typography>
    </ListItemText>
  </ListItemButton>
</NavLink>
                                                    </ListItem>
</span>
                  <span>

                    <ListItem disablePadding sx={{ display: "block" }}>
                     <NavLink to={paths.driverCarrier.vehicles} className="sidelink">
  <ListItemButton
    onClick={(event) => handleCreateBookingClick(event, "vehicles")}
    spacing={4}
    sx={{
      minHeight: 48,
      justifyContent: open ? "initial" : "center",
      px: 2.5,
      color: "white",
    }}
  >
    <ListItemIcon
      sx={{
        minWidth: 0,
        mr: open ? 3 : "auto",
        justifyContent: "center",
        color: "white",
      }}
    >
      <img src={vehiclelogo} width="20px" />
    </ListItemIcon>
    <ListItemText>
      <Typography sx={{ marginInlineStart: "19px" }}>
        Add / Edit Vehicles
      </Typography>
    </ListItemText>
  </ListItemButton>
</NavLink>
                    </ListItem>
                  </span>



                    <span>
                    

                    <ListItem disablePadding sx={{ display: "block" }}>
                      <NavLink
                      to={paths.driverCarrier.editProfile}
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                            <EditIcon />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography sx={{ marginInlineStart: "19px" }}>
                              Edit Profile
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <NavLink
                      to={paths.driverCarrier.MyBookingsReport}
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                            <EditIcon />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography sx={{ marginInlineStart: "19px" }}>
                              My Booking Reports
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>
                     <ListItem disablePadding sx={{ display: "block" }}>
                      <NavLink
                      to={paths.driverCarrier.carrierRideHistory}
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                            <EditIcon />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography sx={{ marginInlineStart: "19px" }}>
                              Ride History
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>
                    <ListItem disablePadding sx={{ display: "block" }}>
                      <NavLink
                      to={paths.driverCarrier.carrierInvoiceHistory}
                      className="sidelink"
                    >
                        <ListItemButton
                          spacing={4}
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                            color: "white",
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 0,
                              mr: open ? 3 : "auto",
                              justifyContent: "center",
                              color: "white",
                            }}
                          >
                            <EditIcon />
                          </ListItemIcon>
                          <ListItemText>
                            <Typography sx={{ marginInlineStart: "19px" }}>
                            Invoice History
                            </Typography>
                          </ListItemText>
                        </ListItemButton>
                      </NavLink>
                    </ListItem>

                    <ListItem disablePadding sx={{ display: "block" }}>
  <ListItemButton
    spacing={4}
    sx={{
      minHeight: 48,
      justifyContent: open ? "initial" : "center",
      px: 2.5,
      color: "white",
    }}
  >
    <ListItemIcon
      sx={{
        minWidth: 0,
        mr: open ? 3 : "auto",
        justifyContent: "center",
        color: "white",
      }}
    >
      <FunctionsIcon />
    </ListItemIcon>
    <ListItemText>
      <Typography sx={{ marginInlineStart: "19px" }}>
        <FormControl variant="standard" fullWidth>
          <Select
            size="small"
            sx={{
              color: "white",
              ".MuiSvgIcon-root": {
                color: "#fff",
              },
            }}
            value={policy}
            onChange={handleSelectChange}
          >
            <MenuItem
              value="Terms and Conditions"
              onClick={() => handleMenuItemClick("Terms and Conditions")}
            >
              Terms and Conditions
            </MenuItem>
            <MenuItem
              value="Cancellation Policy"
              onClick={() => handleMenuItemClick("Cancellation Policy")}
            >
              Cancellation Policy
            </MenuItem>
          </Select>
        </FormControl>
      </Typography>
    </ListItemText>
  </ListItemButton>
</ListItem>

                  </span>
                
              </List>

              <Button
                className="ms-4"
                sx={{
                  backgroundColor: "#FF4848",
                  borderRadius: "10px",
                  maxWidth: "190px",
                  ":hover": {
                    backgroundColor: "#FF2626",
                  },
                }}
                onClick={handleLogout}
                style={{ color: "white", fontWeight: "700" }}
              >
                <PowerSettingsNewIcon
                  className="me-1"
                  sx={{ height: "18px", width: "18px" }}
                />{" "}
                Log Out
              </Button>
            </Drawer>
          </div>
          <div style={{ width: "100%", backgroundColor: "#fff" }}>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
